module.exports = __webpack_public_path__ + "img/lovely.9f95d59a.svg";